export interface CollapsePillsArgs<Item> {
  items: Item[];
  /** How many pills stay visible while collapsed; pinned items raise it when there are more of them. */
  minVisible: number;
  /** Items that always sort first and are never hidden behind the "+N more" chip. */
  pinFirst?: (item: Item) => boolean;
  expanded: boolean;
}

export interface CollapsePillsResult<Item> {
  visible: Item[];
  hiddenCount: number;
  isCollapsible: boolean;
}

export const collapsePills = <Item>({
  items,
  minVisible,
  pinFirst,
  expanded,
}: CollapsePillsArgs<Item>): CollapsePillsResult<Item> => {
  const pinned = pinFirst ? items.filter((item) => pinFirst(item)) : [];
  const rest = pinFirst ? items.filter((item) => !pinFirst(item)) : items;
  const ordered = [...pinned, ...rest];

  const keep = Math.max(minVisible, pinned.length);
  const overflow = ordered.length - keep;

  const isCollapsible = overflow >= 1;

  if (expanded || !isCollapsible) {
    return { visible: ordered, hiddenCount: 0, isCollapsible };
  }

  return { visible: ordered.slice(0, keep), hiddenCount: overflow, isCollapsible };
};
